import React from "react"
import PropTypes from "prop-types"
import lottie from 'lottie-web'


class SearchBar extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      text: ''
    }
    this.onChange = this.onChange.bind(this)
  }

  componentDidMount() {
    lottie.loadAnimation({
      container: document.getElementById('search'),
      renderer: 'svg',
      loop: true,
      autoplay: false,
      name: 'search',
      path: this.props.searchLottie
    });
    lottie.pause()
  }

  onChange(event) {
    this.props.updateSearchText(event.target.value)
    lottie.play('search')
    lottie.pause('search')
  }

  render() {
      return(
        <div style={{textAlign: 'center'}}>
          <input style={{
            margin: 'auto',
            backgroundColor: 'white',
            border: "2px solid #03A9F4",
            maxWidth: 350,
            width: '99%',
            flexDirection: 'row',
            justifyContent: 'space-between',
            display: 'flex',
            borderRadius: 30,
            marginTop: 12,
            marginBottom: 12,
            cursor: 'pointer',
            height: 35,
            paddingLeft: 15,
            fontSize: 14,
            color: '#01579B',
            display: 'inline-block'
          }}
          onChange={this.onChange}
          text={this.props.searchText}/>
          <div id="search" style={{display: 'inline-block', width: 45, height: 45, marginLeft: -45}}></div>
        </div>
      )
  }
}

export default SearchBar;
